import React from 'react'

export function IconContent({ as: Comp = 'div', children, ...rest }) {
  return (
    <Comp {...rest} data-icon-content="">
      {children}
    </Comp>
  )
}

export function IconContentText({ as: Comp = 'div', children, ...rest }) {
  return (
    <Comp {...rest} data-icon-content-text="">
      {children}
    </Comp>
  )
}
